import work from './work';

const carpenter = {
	consume: { food: 1, water: 1 },
	resilience: { food: 1, water: 1 },
	craftsmanship: { craftsmanship: 2 },
	luck: { luck: 1 },
	charisma: { charisma: 1 },
	startBonus: {},

	work: { [work.forage]: 0.8, [work.craft]: 2, [work.fabricate]: 2 },
};

export default carpenter;
